module.exports = __webpack_public_path__ + "img/23.71bdd6ed.png";